export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10565.e8ed2f3b.jpg";